import {Formik} from 'formik';
import React, {useState} from 'react';
import {Button, Modal, Row} from 'react-bootstrap';
import {FormattedMessage, useIntl} from 'react-intl';
import Col from "react-bootstrap/Col";
import {TextInputField} from "../bootstrap/TextInputField";
import * as yup from "yup";
import {Validator} from "../../utils/Validator";
import {SingleUploadArea} from "../SingleUploadArea";
import {validateNifIncubation} from "../../rest/incubation";
import {AlertError} from "../bootstrap/AlertError";
import {createCustomErrorMessage} from "../../hooks/errorMessage";


export function IncubatorContractDialog({
                                             show,
                                             handleClose,
                                             handleSubmit
                                         }) {


    const [error, setError] = useState(null);
    const [documents, setDocuments] = useState([]);
    const [validNif,setValidNif] = useState(false);
    const intl = useIntl();

    const schema = yup.object().shape({
        promoterNif: yup
        .string()
        .required(<FormattedMessage id='errors.fieldRequiredText'/>)
        .test(
            'isNifValid',
            <FormattedMessage id='errors.promoterForm.nif'/>,
            (value) => Validator.validateNif(value)
        ),
        file: yup.mixed().required(<FormattedMessage id='errors.fieldRequiredText'/>),
    });

    const clean = async () => {
        setError(null);
        setValidNif(false);
        handleClose();
    }

    const validateNif = async (values) => {
        try {

            const [{ data: dataResponse }] = await Promise.all([
                await validateNifIncubation(values.promoterNif),
            ]);
            setValidNif(dataResponse);
        } catch (e) {
            if (e.response.data.exception === 'ObjectNotFoundException') {
                setError(
                    createCustomErrorMessage(intl.formatMessage({ id: 'error.reports.interestExpressionNotExist' }))
                );

            }
            else{
                setError(e);
            }

        }
        return true;
    }

    /*if (error && isNotBusinessError(error)) {
        return handleError(error);
    }*/



    const handleNifChange = async (e,values,setFieldValue) => {
        setDocuments([]);
        setFieldValue('file',null)
        setValidNif(false)
        setFieldValue('promoterNif', e.target.value)
    }

    return (
        <Modal show={show} onHide={clean}>
            <Modal.Header closeButton>
                <Modal.Title>
                    <FormattedMessage id={`incubator.contract.add`}/>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Formik
                    initialValues={{promoterNif: ''}}
                    validateOnBlur={false}
                    validationSchema={schema}
                    validateOnChange={false}
                    onSubmit={(values, {setSubmitting, setErrors}) => {
                        handleSubmit(values, setSubmitting, setErrors);
                    }}
                >
                    {({

                          values,
                          errors,
                          touched,
                          handleChange,
                          handleSubmit,
                          setFieldValue,
                      }) => (
                        <form onSubmit={handleSubmit}>

                                <Row>
                                    <Col>
                                        <AlertError error={error} />
                                    </Col>
                                </Row>
                                <Row className='align-items-end'>
                                    <Col md={9}>

                                        <TextInputField
                                            controlId={'promoterNif'}
                                            labelId={'incubator.nifPromoter'}
                                            name={'promoterNif'}

                                            handleChange={(e) => handleNifChange(e,values,setFieldValue)}
                                            value={values.promoterNif}
                                            isInvalid={errors.promoterNif}
                                            errorMessage={errors.promoterNif}
                                        />
                                    </Col>
                                    <Col md={3} className={'mt-1'}>
                                        <button className='btn btn-outline-secondary' type='button' onClick={() => validateNif(values)}>
                                            <FormattedMessage id='all.validate'/>
                                        </button>
                                    </Col>
                                </Row>





                            {validNif &&
                            <div className={errors.file ? ' ps-3  pe-3 square border border-danger border-2 mt-3' : 'mt-3'}>
                                <SingleUploadArea
                                    documents={documents}
                                    setDocuments={setDocuments}
                                    documentType={'INTEREST_EXPRESSION'}
                                    setError={setError}
                                    processUploadCallback={formData => setFieldValue('file', formData)}
                                />
                                {errors.file && <span className={'text-danger'}> {errors.file}</span>}
                            </div>
                            }

                            <Row className='form-actions'>
                                <Col className='justify-content-between d-flex'>
                                    <button className='btn btn-outline-primary' type='button' onClick={handleClose}>
                                        <FormattedMessage id='all.cancel'/>
                                    </button>
                                    {validNif && <Button variant='primary' type='submit'>
                                        <FormattedMessage id='all.submitButtonText'/>
                                    </Button>}
                                </Col>
                            </Row>
                        </form>
                    )}
                </Formik>
            </Modal.Body>
        </Modal>
    );
}
